var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":_vm.onClick}},[(_vm.isCollapsed)?_c('icon-plus',{key:"minus",staticClass:"button__icon"}):_c('icon-minus',{key:"plus",staticClass:"button__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }